import { render } from "./zixunDetail.vue?vue&type=template&id=969a0c86&scoped=true"
import script from "./zixunDetail.vue?vue&type=script&lang=js"
export * from "./zixunDetail.vue?vue&type=script&lang=js"

import "./zixunDetail.vue?vue&type=style&index=0&id=969a0c86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-969a0c86"]])

export default __exports__